import { z } from 'zod';

import { getValue } from 'models';

import { domain, domainSchema } from './domain';
import { environmentLockAccess, environmentLockAccessSchema } from './environment-lock-access';
import { hostname, hostnameSchema } from './hostname';
import { parseConfig } from './parse-config';
import { urlConfig, urlConfigSchema } from './url-config';

const publicConfigSchema = z.object({
    environment: z.string().default('development'),
    environmentLockAccess: environmentLockAccessSchema,
    domain: domainSchema,
    hostname: hostnameSchema,
    urls: urlConfigSchema,
    sentryPublicKey: z.string().optional(),
    ablyPublicKey: z.string().optional(),
    userSnapPublicKey: z.string().optional(),
    mapboxPublicKey: z.string().optional(),
    imageKitPublicKey: z.string().optional(),
    analyticsPublicKey: z.string().optional(),
    release: z.string().optional(),
});

export type PublicConfig = z.infer<typeof publicConfigSchema>;

export const publicConfig: PublicConfig = parseConfig('public configuration', publicConfigSchema, {
    environment: process.env.NEXT_PUBLIC_ENVIRONMENT,
    environmentLockAccess,
    domain,
    hostname,
    urls: urlConfig,
    sentryPublicKey: process.env.NEXT_PUBLIC_SENTRY,
    ablyPublicKey: process.env.NEXT_PUBLIC_ABLY_API_KEY,
    analyticsPublicKey: process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS,
    userSnapPublicKey: process.env.NEXT_PUBLIC_USERSNAP_SPACE_API_KEY,
    mapboxPublicKey: process.env.NEXT_PUBLIC_MAPBOX_API_KEY,
    imageKitPublicKey: process.env.NEXT_PUBLIC_IMAGEKIT,
    release: process.env.NEXT_PUBLIC_RELEASE,
});
